import {ExtraReducer, ReducerFromState} from "../../../@types/reducers";

export const getTemplate = (state: ReducerFromState<ExtraReducer>): null | string => state.extra.template;
